import { render, staticRenderFns } from "./left-side.vue?vue&type=template&id=4c5fa186&scoped=true"
import script from "./left-side.vue?vue&type=script&lang=js"
export * from "./left-side.vue?vue&type=script&lang=js"
import style0 from "./left-side.vue?vue&type=style&index=0&id=4c5fa186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5fa186",
  null
  
)

export default component.exports